import React from "react";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { iconFor } from "@/lib/icons";
import { resolveCtaHref, isExternalCta } from "@/lib/cta";
import { trackCta } from "@/lib/analytics";

export const ResearchTraining = () => {
    const { content } = useContent();
    const r = content.research_training;
    const items = (r.items || []).filter((it) => it.visible !== false);

    return (
        <section id="research-training" data-testid="research-training-section" className="bg-slate-50 py-24 lg:py-28">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl">
                    <p className="label-eyebrow">{r.eyebrow}</p>
                    <h2 data-testid="research-training-title" className="mt-4 font-display font-semibold text-slate-900 text-3xl sm:text-4xl lg:text-[42px] leading-[1.1] tracking-tight">
                        {r.title}
                    </h2>
                    <p className="mt-5 text-base lg:text-lg text-slate-600 font-body leading-relaxed">{r.subtitle}</p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6">
                    {items.map((item) => {
                        const Icon = iconFor(item.icon);
                        const testId = `training-card-${item.key}`;
                        const href = resolveCtaHref(item, content.contact);
                        const external = isExternalCta(item);
                        return (
                            <article key={item.key} data-testid={testId} className="card-lift bg-white border border-slate-200 p-8 flex flex-col">
                                <span className="inline-flex items-center justify-center w-12 h-12 bg-teal-600/10 text-teal-700">
                                    <Icon strokeWidth={1.5} className="w-6 h-6" />
                                </span>
                                <h3 className="mt-6 font-display text-xl font-semibold text-slate-900 leading-snug">{item.title}</h3>
                                <p className="mt-3 text-[14.5px] text-slate-600 font-body leading-relaxed flex-1">{item.desc}</p>
                                <div className="mt-6 pt-5 border-t border-slate-100">
                                    <a
                                        href={href}
                                        target={external ? "_blank" : undefined}
                                        rel={external ? "noopener noreferrer" : undefined}
                                        data-testid={`${testId}-cta`}
                                        onClick={() => trackCta("research_workshop_enquiry_click", { source: "research_training_section", label: testId })}
                                        className="btn-link-teal"
                                    >
                                        {item.cta_label}
                                        <ArrowRight className="w-4 h-4" />
                                    </a>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ResearchTraining;
